// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_publication_model from "./web_publication_model.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function cancel(t) {
  t.generation = t.generation + 1 | 0;
  t.revision = t.revision + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
  t.loading = false;
  t.dirty = false;
}

function path(t) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function" || !(match.TAG === /* Session */ 3 && !Mapre_web__Web_model.locked(Curry._1(t.model, undefined)))) {
    return;
  } else {
    return "/api/workspaces/" + (match._0 + ("/sessions/" + (match._2 + "/publication")));
  }
}

function active(t, generation) {
  if (generation === t.generation) {
    return path(t) !== undefined;
  } else {
    return false;
  }
}

function refresh(t) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  if (t.loading) {
    t.dirty = true;
    return;
  }
  t.loading = true;
  t.dirty = false;
  const generation = t.generation;
  const revision = t.revision;
  Mapre_web__Browser.request(t.controller, undefined, undefined, path$1).then(function (result) {
    if (active(t, generation)) {
      t.loading = false;
      if (revision !== t.revision) {
        t.dirty = true;
      } else if (result.TAG === /* Ok */ 0) {
        try {
          const action = {
            TAG: /* Loaded */ 3,
            _0: Mapre_web__Web_publication_model.decode(result._0)
          };
          Curry._1(t.emit, {
            TAG: /* Publication */ 45,
            _0: action
          });
          Stdlib__Option.iter((function (s) {
            Curry._1(t.emit, {
              TAG: /* Publication */ 45,
              _0: {
                TAG: /* Default_title */ 2,
                _0: s.title
              }
            });
          }), Curry._1(t.model, undefined).selected);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.emit, {
              TAG: /* Publication */ 45,
              _0: {
                TAG: /* Message */ 7,
                _0: "Invalid publication response."
              }
            });
          } else {
            throw exn;
          }
        }
      } else {
        const error = result._0;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          if (error === /* Unauthorized */ 0) {
            Curry._1(t.failure, error);
          } else {
            Curry._1(t.emit, {
              TAG: /* Publication */ 45,
              _0: {
                TAG: /* Message */ 7,
                _0: "Unable to refresh publication. Retry when online."
              }
            });
          }
        } else if (error.TAG === /* Missing */ 0) {
          Curry._1(t.failure, error);
        } else {
          Curry._1(t.emit, {
            TAG: /* Publication */ 45,
            _0: {
              TAG: /* Message */ 7,
              _0: "Unable to refresh publication. Retry when online."
            }
          });
        }
      }
      if (t.dirty) {
        refresh(t);
      }
      
    }
    return Promise.resolve();
  });
}

function failed(t, error) {
  if (/* tag */ typeof error !== "object" && typeof error !== "function") {
    switch (error) {
      case /* Unauthorized */ 0 :
        return Curry._1(t.failure, error);
      case /* Forbidden */ 1 :
        return Curry._1(t.emit, {
          TAG: /* Publication */ 45,
          _0: /* Denied */ 0
        });
      case /* Invalid_response */ 2 :
        Curry._1(t.emit, {
          TAG: /* Publication */ 45,
          _0: {
            TAG: /* Delivery */ 5,
            _0: /* Uncertain */ 1
          }
        });
        return refresh(t);
    }
  } else {
    if (error.TAG === /* Missing */ 0) {
      return Curry._1(t.failure, error);
    }
    switch (error._0) {
      case "invalid_publication_input" :
        return Curry._1(t.emit, {
          TAG: /* Publication */ 45,
          _0: {
            TAG: /* Failed */ 6,
            _0: "Check the PR title and description before publishing."
          }
        });
      case "publication_intent_conflict" :
      case "publication_source_changed" :
      case "publication_source_missing" :
      case "publication_turn_unconfirmed" :
      case "run_changed" :
      case "version_conflict" :
        break;
      default:
        Curry._1(t.emit, {
          TAG: /* Publication */ 45,
          _0: {
            TAG: /* Delivery */ 5,
            _0: /* Uncertain */ 1
          }
        });
        return refresh(t);
    }
    Curry._1(t.emit, {
      TAG: /* Publication */ 45,
      _0: {
        TAG: /* Failed */ 6,
        _0: "The run changed. Review the current state before publishing again."
      }
    });
    return refresh(t);
  }
}

function send(t, attempt) {
  const path$1 = path(t);
  if (path$1 === undefined) {
    return;
  }
  t.revision = t.revision + 1 | 0;
  Curry._1(t.emit, {
    TAG: /* Publication */ 45,
    _0: {
      TAG: /* Started */ 4,
      _0: {
        id: attempt.id,
        run_id: attempt.run_id,
        version: attempt.version,
        title: attempt.title,
        body: attempt.body,
        phase: /* Sending */ 0
      }
    }
  });
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, Mapre_web__Web_publication_model.body(attempt), path$1).then(function (result) {
    const current = Curry._1(t.model, undefined).publication.attempt;
    if (active(t, generation) && Stdlib__Option.fold(false, (function (a) {
        if (a.id === attempt.id) {
          return a.run_id === attempt.run_id;
        } else {
          return false;
        }
      }), current)) {
      t.revision = t.revision + 1 | 0;
      if (result.TAG === /* Ok */ 0) {
        try {
          const publication = Mapre_web__Web_publication_model.decode_publication(result._0);
          if (publication.id !== attempt.id || publication.run_id !== attempt.run_id) {
            failed(t, /* Invalid_response */ 2);
          } else {
            Curry._1(t.emit, {
              TAG: /* Publication */ 45,
              _0: {
                TAG: /* Delivery */ 5,
                _0: /* Accepted */ 2
              }
            });
            refresh(t);
          }
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            failed(t, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        failed(t, result._0);
      }
    }
    return Promise.resolve();
  });
}

function dispatch(t, action) {
  if (!/* tag */ (typeof action !== "object" && typeof action !== "function")) {
    return Curry._1(t.emit, {
      TAG: /* Publication */ 45,
      _0: action
    });
  }
  switch (action) {
    case /* Refresh */ 2 :
      const generation = t.generation;
      if (path(t) !== undefined) {
        Mapre_web__Browser.request(t.controller, undefined, undefined, "/api/workspaces").then(function (result) {
          if (active(t, generation)) {
            if (result.TAG === /* Ok */ 0) {
              try {
                Curry._1(t.emit, {
                  TAG: /* Workspaces */ 1,
                  _0: Mapre_web__Web_codec.workspaces(result._0)
                });
                Curry._1(t.emit, {
                  TAG: /* Publication */ 45,
                  _0: /* Access_refreshed */ 1
                });
                refresh(t);
              }
              catch (raw_exn){
                const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
                  Curry._1(t.emit, {
                    TAG: /* Publication */ 45,
                    _0: {
                      TAG: /* Message */ 7,
                      _0: "Invalid access response."
                    }
                  });
                } else {
                  throw exn;
                }
              }
            } else {
              Curry._1(t.failure, result._0);
            }
          }
          return Promise.resolve();
        });
        return;
      } else {
        return;
      }
    case /* Submit */ 3 :
      const m = Curry._1(t.model, undefined);
      if (!(Mapre_web__Web_model.can_create(m) && Mapre_web__Web_publication_model.can_submit(m.publication))) {
        return;
      }
      const control = Stdlib__Option.get(m.publication.control);
      return send(t, {
        id: crypto.randomUUID(),
        run_id: Stdlib__Option.get(control.run_id),
        version: control.version,
        title: m.publication.title,
        body: m.publication.body,
        phase: /* Sending */ 0
      });
    case /* Stop */ 4 :
      const model = Curry._1(t.model, undefined);
      const match = path(t);
      const match$1 = model.publication.control;
      if (match === undefined) {
        return;
      }
      if (match$1 === undefined) {
        return;
      }
      if (!(Mapre_web__Web_model.can_create(model) && match$1.can_stop && !match$1.stop_requested)) {
        return;
      }
      const endpoint = Stdlib__String.sub(match, 0, match.length - 11 | 0) + "stop";
      const body = JSON.stringify(Js__Js_dict.fromList({
        hd: [
          "run_id",
          Mapre_wire__Json.str(Stdlib__Option.get(match$1.run_id))
        ],
        tl: /* [] */ 0
      }));
      const generation$1 = t.generation;
      t.revision = t.revision + 1 | 0;
      Mapre_web__Browser.request(t.controller, undefined, body, endpoint).then(function (result) {
        if (active(t, generation$1)) {
          if (result.TAG === /* Ok */ 0) {
            Curry._1(t.emit, {
              TAG: /* Publication */ 45,
              _0: {
                TAG: /* Message */ 7,
                _0: "Stop requested; waiting for sandbox confirmation."
              }
            });
          } else {
            const error = result._0;
            if (/* tag */ typeof error !== "object" && typeof error !== "function") {
              switch (error) {
                case /* Unauthorized */ 0 :
                  Curry._1(t.failure, error);
                  break;
                case /* Forbidden */ 1 :
                  Curry._1(t.emit, {
                    TAG: /* Publication */ 45,
                    _0: /* Denied */ 0
                  });
                  break;
                case /* Invalid_response */ 2 :
                  Curry._1(t.emit, {
                    TAG: /* Publication */ 45,
                    _0: {
                      TAG: /* Message */ 7,
                      _0: "Unable to confirm stop. Refresh and retry the same session."
                    }
                  });
                  break;
              }
            } else if (error.TAG === /* Missing */ 0) {
              Curry._1(t.failure, error);
            } else {
              Curry._1(t.emit, {
                TAG: /* Publication */ 45,
                _0: {
                  TAG: /* Message */ 7,
                  _0: "Unable to confirm stop. Refresh and retry the same session."
                }
              });
            }
          }
          refresh(t);
        }
        return Promise.resolve();
      });
      return;
    case /* Retry */ 5 :
      const m$1 = Curry._1(t.model, undefined);
      if (Mapre_web__Web_model.can_create(m$1) && !m$1.publication.denied) {
        return Stdlib__Option.iter((function (a) {
          if (a.phase === /* Uncertain */ 1) {
            return send(t, a);
          }
          
        }), m$1.publication.attempt);
      } else {
        return;
      }
    default:
      return Curry._1(t.emit, {
        TAG: /* Publication */ 45,
        _0: action
      });
  }
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    revision: 0,
    controller: new AbortController(),
    loading: false,
    dirty: false
  };
}

export {
  create,
  cancel,
  refresh,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
